import type { CustomIconProps } from '../CustomIcon';

export function DepthOfColour(props: CustomIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="3752.88 61.85 360 360" {...props}>
      <defs>
        <clipPath id="clippath">
          <circle fill="none" cx="3932.87" cy="241.83" r="176.99" />
        </clipPath>
      </defs>
      <path
        fill="currentColor"
        d="M3932.87,64.85c-97.75,0-176.99,79.24-176.99,176.99s79.24,176.99,176.99,176.99,176.99-79.24,176.99-176.99-79.24-176.99-176.99-176.99M3932.87,70.26c94.61,0,171.58,76.97,171.58,171.58s-76.97,171.58-171.58,171.58-171.58-76.97-171.58-171.58,76.97-171.58,171.58-171.58"
      />
      <rect
        fill="currentColor"
        strokeWidth={1}
        x="3887.12"
        y="228.25"
        width="85.74"
        height="7.63"
      />
      <path
        fill="currentColor"
        strokeWidth={1}
        d="M3972.86,238.17h-85.74c.96,10.58,14.2,9.31,27.46,19.73,13.26,10.42,7.57,37.43,4.78,50.12-1.58,7.19-10.46,85.32,17,85.32,21.39,0,11.21-79.95,9.31-85.63-1.89-5.68-12.16-43.18,7.73-52.66,19.89-9.47,19.45-16.89,19.45-16.89ZM3934.02,372.52c-3.14,0-5.68-4.66-5.68-10.42s2.54-10.42,5.68-10.42,5.68,4.66,5.68,10.42-2.54,10.42-5.68,10.42Z"
      />
      <g clipPath="url(#clippath)">
        <path
          strokeWidth={1}
          fill="currentColor"
          d="M3887.54,144.47s7.59-9.47,19.91-9.47,12.31,10.42,21.78,10.42,8.52-11.37,20.84-11.37c10.78.51,6.75,12.72,22.27,6.7,0,0-.92-105.33.7-103.71,1.62,1.62-85.22,0-85.22,0l-.28,107.43Z"
        />
        <path
          strokeWidth={1}
          fill="currentColor"
          d="M3967.97,50.59v170.32h-75.97V50.59h75.97M3972.86,45.71h-85.74v180.1h85.74V45.71h0Z"
        />
      </g>
    </svg>
  );
}
